import { type MutationError, trpc } from '@/shared/api';

interface UseRetryPaymentCancelOptions {
  /** 돌려준 promise 가 끝날 때까지 isPending 이 유지된다. */
  readonly onSuccess?: () => unknown;
  /**
   * 성공이든 오류든 요청이 끝나면 부른다 — 토스가 거절하면 서버가 그 행을 FAILED 로 바꾸고 오류를 던져 다시 불러올 일이 생긴다.
   * 돌려준 promise(재조회)가 끝날 때까지 isPending 이 유지된다.
   */
  readonly onSettled?: () => unknown;
}

interface UseRetryPaymentCancelResult {
  readonly retry: (cancelId: string) => void;
  readonly isPending: boolean;
  readonly error: MutationError | null;
  readonly reset: () => void;
}

/** 결과를 모르는 PENDING 환불 다시 시도(paymentManagement.retryCancel) — 같은 멱등키라 이중 환불이 없다. */
export const useRetryPaymentCancel = ({
  onSuccess,
  onSettled,
}: UseRetryPaymentCancelOptions = {}): UseRetryPaymentCancelResult => {
  const mutation = trpc.paymentManagement.retryCancel.useMutation({ onSuccess, onSettled });

  return {
    retry: (cancelId) => mutation.mutate({ cancelId }),
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
};
